const environment = () => {
  console.log('Loading environment.js...');
  console.log('Window location:', window.location.hostname);
  console.log('NODE_ENV:', process.env.NODE_ENV);
  
  // Detailed AWS credentials debug
  const awsCredentials = {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    s3Bucket: process.env.REACT_APP_AWS_S3_BUCKET || 'fsapplications'
  };

  console.log('AWS Credentials Check:', {
    accessKeyExists: !!awsCredentials.accessKeyId,
    secretKeyExists: !!awsCredentials.secretAccessKey,
    accessKeyLength: awsCredentials.accessKeyId?.length || 0,
    secretKeyLength: awsCredentials.secretAccessKey?.length || 0,
    region: awsCredentials.region,
    bucket: awsCredentials.s3Bucket
  });

  const config = {
    nodeEnv: process.env.NODE_ENV || 'development',
    apiUrl: getApiUrl(),
    isProduction: process.env.NODE_ENV === 'production',
    aws: {
      // Use the AWS credentials we just logged
      ...awsCredentials,
      receiptBucket: process.env.REACT_APP_AWS_RECEIPT_BUCKET || 'sponsfi-reciept-storage'
    },
    apiVersion: process.env.REACT_APP_API_VERSION || 'v1'
  };

  // Final config check (safe to log as it doesn't show actual credentials)
  console.log('Final Config Check:', {
    nodeEnv: config.nodeEnv,
    apiUrl: config.apiUrl,
    awsConfigured: !!(config.aws.accessKeyId && config.aws.secretAccessKey),
    awsRegion: config.aws.region,
    awsBucket: config.aws.s3Bucket,
    apiVersion: config.apiVersion
  });

  return config;
};

function getApiUrl() {
  const hostname = window.location.hostname;
  
  // Production domain check
  if (hostname === 'causeandimpact.org' || hostname === 'www.causeandimpact.org') {
    return 'https://api.causeandimpact.org';
  }
  
  // Local development
  if (hostname === 'localhost') {
    return process.env.REACT_APP_API_URL || 'http://localhost:5000';
  }
  
  // Local network
  if (hostname === '192.168.1.174') {
    return 'http://192.168.1.174:5000';
  }

  // Default fallback
  return 'https://api.causeandimpact.org';
}

export default environment;